import {calculateEnemyDemonsInRange} from "../../factions/demons/calculateEnemyDemonsInRange";
import {DEMONS_AMOUNT_FACTOR, DEMONS_COMBAT_BONUS_DEBUFF} from "../../../configs/factions/demons";
import {checkIfUnitMeleeElf} from "../../factions/elves/checkIfUnitMeleeElf";

/**
 * Рассчитывает урон от выстрела катапульты
 * @param {Object} shootingUnit - отряд стреляющий (катапульта)
 * @param {Array} pendingMovementActions - массив отложенных действий перемещения для проверки ходил ли отряд
 * @param {number} diceRoll1
 * @param {number} diceRoll2
 * @param {Array} units
 * @param {Array} players
 * @param {string | null} targetUnitOwnerId
 * @param {string | null} targetHexOwnerId
 * @returns {{damage: number, bonus: number}} итоговый урон и размер бонуса
 */
export const calculateShootingDamage = (shootingUnit, pendingMovementActions, diceRoll1, diceRoll2, units, players, targetUnitOwnerId,
                                        targetHexOwnerId) => {
  let bonus = 0;
  let damage;

  const baseDamage = shootingUnit.size;

  // Проверяем перемещался ли отряд катапульты в текущей фазе
  const hasMoved = pendingMovementActions.some(action => action.unitId === shootingUnit.id);

  // Если перемещался - выбираем худший бросок (минимальный), если нет - лучший (максимальный)
  const selectedDiceRoll = hasMoved
    ? Math.min(diceRoll1, diceRoll2)
    : Math.max(diceRoll1, diceRoll2);

  const targetsOwnerIds = new Set([targetUnitOwnerId]);
  if (!checkIfUnitMeleeElf(shootingUnit)) {
    targetsOwnerIds.add(targetHexOwnerId);
  }

  // Расчет бонуса при стрельбе против демонов. Проверка идет по юнитам конкретного
  // игрока (calculateEnemyDemonsInRange уже фильтрует по unit.factionId), а не по
  // фракции самого игрока - иначе демонский юнит, захваченный Суккубом, перестал бы
  // давать дебафф при стрельбе (см. unit-scoped-faction-abilities)
  for (const targetPlayerId of [...targetsOwnerIds]) {
    if ((targetPlayerId === shootingUnit.ownerId) || (!targetPlayerId)) {
      continue;
    }

    const enemyDemonsAmount = calculateEnemyDemonsInRange(shootingUnit.ownerId, shootingUnit.hexKey, units, targetPlayerId);

    bonus += Math.floor(enemyDemonsAmount / DEMONS_AMOUNT_FACTOR) * DEMONS_COMBAT_BONUS_DEBUFF;
  }

  bonus = Math.min(bonus, shootingUnit.size);

  if (checkIfUnitMeleeElf(shootingUnit)) {
    // Половина ближнего боя, 0.5 округляется вверх
    damage = Math.max(0, Math.ceil((baseDamage + diceRoll1 + diceRoll2 + bonus) / 2));
  } else {
    damage = Math.max(0, baseDamage + selectedDiceRoll + bonus);
  }

  return {
    damage,
    bonus,
  };
};

/**
 * Рассчитывает суммарный урон по отряду из всех pendingShootingActions
 * @param {string} targetUnitId - ID целевого отряда
 * @param {Array} pendingShootingActions - массив отложенных действий стрельбы
 * @returns {number} суммарный урон
 */
export const calculateTotalDamageForUnit = (targetUnitId, pendingShootingActions) => {
  if (!pendingShootingActions || pendingShootingActions.length === 0) {
    return 0;
  }

  return pendingShootingActions
    .filter(action => action.targetUnitId === targetUnitId)
    .reduce((total, action) => total + action.damage, 0);
};
